<div class="tagCategoryDs__cont">
  <ng-container *ngIf="tagIcon">
    <div class="tagCategoryDs__icon">
      <app-ds-icon
        [icon]="tagIcon"
        [color]="iconColor"
        [size]="iconSize">
      </app-ds-icon>
    </div>
  </ng-container>
  <app-ds-typography
    [size]="fontSize"
    [color]="fontColor"
    [fontFamily]="fontFamily.SemiBold"
    [text]="label">
  </app-ds-typography>
</div>